export class orgcode {
	constructor(
		public Id: string,
		public orgTypeId: string,
		public description?: string,
		public parentId?: string,
		public status?: number
	) { }
}